export default __webpack_public_path__ + "static/thumb-bpress-6d944e412ff135d13a58b1ca2d5afcac.jpg";